import { IResponse } from '@zmedia/bm-soccer-ui/interface';
import { getWithPath } from '@zmedia/bm-soccer-ui/utils/http';

const API_PATH = {
    GET_LIST: '/tournament/get/list',
    GET_FULL_LIST: '/tournament/get/list-top',
    GET_RANKING_LIST: '/tournament/ranking/get/list',
    GET_RANKING_DETAIL: '/tournament/ranking/get/detail',
    GET_KNOCKOUT: '/tournament/get/knockout'

};

export const TournamentService = {
    getList: (): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_LIST, { listType: "byOustanding" });
    },
    getFullList: (): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_FULL_LIST);
    },
    getRankingList: (params: any): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_RANKING_LIST, params);
    },
    getRankingDetail: (params: any): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_RANKING_DETAIL, params);
    },
    getKnockout: (params: any): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_KNOCKOUT, params);
    },
};

export default TournamentService;
